import { api as client } from './api';

// Shared client just for logging (no auth needed for logs usually, or it uses ephemeral trace)

type LogLevel = 'info' | 'warn' | 'error' | 'debug';

interface LogMetadata {
    [key: string]: unknown;
    stack?: string | undefined;
    url?: string | undefined;
    userAgent?: string | undefined;
}

function send(level: LogLevel, message: string, metadata?: LogMetadata): void {
    // DIAMOND: metadata must be an object, not a string
    const payload = {
        source: 'app',
        level,
        message,
        metadata: {
            ...metadata,
            url: typeof window !== 'undefined' ? window.location.href : undefined,
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
            timestamp: new Date().toISOString(),
        },
    };

    // Fire and forget
    client.log(payload).catch(() => {
        // Silent fail
    });
}

export const logger = {
    debug: (msg: string, meta?: LogMetadata) => send('debug', msg, meta),
    info: (msg: string, meta?: LogMetadata) => send('info', msg, meta),
    warn: (msg: string, meta?: LogMetadata) => send('warn', msg, meta),
    error: (msg: string, meta?: LogMetadata) => send('error', msg, meta),

    /** Helper to log an Error object with stack trace */
    captureError: (message: string, error: unknown, extra?: Record<string, unknown>) => {
        const err = error instanceof Error ? error : new Error(String(error));
        send('error', message, {
            errorName: err.name,
            errorMessage: err.message,
            stack: err.stack,
            ...extra,
        });
    },
};
